var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Tabs, Tab, TabTitleText } from '@patternfly/react-core';
;
const HorizontalNav = (_a) => {
    var _b, _c;
    var { ariaLabel, tabs, defaultActiveKey, onTabSelect } = _a, props = __rest(_a, ["ariaLabel", "tabs", "defaultActiveKey", "onTabSelect"]);
    const [activeTabKey, setActiveTabKey] = React.useState((_c = defaultActiveKey !== null && defaultActiveKey !== void 0 ? defaultActiveKey : (_b = tabs === null || tabs === void 0 ? void 0 : tabs[0]) === null || _b === void 0 ? void 0 : _b.eventKey) !== null && _c !== void 0 ? _c : 0);
    return (React.createElement(Tabs, Object.assign({ mountOnEnter: true, activeKey: activeTabKey, onSelect: (e, eventKey) => {
            setActiveTabKey(eventKey);
            onTabSelect === null || onTabSelect === void 0 ? void 0 : onTabSelect(e, eventKey);
        }, role: "navigation", "aria-label": ariaLabel }, props), tabs.map((tab) => (React.createElement(Tab, Object.assign({}, tab, { title: ['string', 'number', 'boolean'].includes(typeof tab.title) ? React.createElement(TabTitleText, null, tab.title) : tab.title, key: tab.eventKey }), tab.children)))));
};
export default HorizontalNav;
